import Vue from 'vue'
import Vuex from 'vuex'
// import createPersistedState from 'vuex-persistedstate'
import config from './modules/config'
import grid from './modules/grid'
import content from './modules/content'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    grid,
    config,
    content,
  },
  // eslint-disable-next-line no-undef
  // strict: process.env.NODE_ENV !== 'production',
  // plugins: [
  //   createPersistedState({
  //     paths: ['documentTemporary']
  //   })
  // ]
})
